import * as Sentry from '@sentry/react';

import { WEB_DSN } from 'src/errorReporting/shared';
import { rendererReportingOptions } from 'src/ui/errorReporting';

import { webEnvironment } from './environment';

/**
 * Starts error reporting in the web build. Called by src/web/index.tsx before the app loads, so an
 * error while it loads — a misconfigured container among them — is reported too.
 *
 * The same options as the desktop's windows; only the project and the way it is started differ.
 * See src/ui/errorReporting.ts.
 */
export function startWebErrorReporting(): void {
  Sentry.init({
    dsn: WEB_DSN,
    ...rendererReportingOptions(environmentOrUnconfigured(), `dictaris-web@${__APP_VERSION__}`),
  });
}

/** Asked before the configuration check has run, so it must not be the thing that throws. */
function environmentOrUnconfigured(): string {
  try {
    return webEnvironment();
  } catch {
    return 'unconfigured';
  }
}
